import { http } from 'services';

import * as Types from './types';
import { getCaptchaToken } from 'helpers/captcha';

export const ByUuid = ({ values }: { values: Types.IForm.ByUuid }) => {
    return http.request.get(`/file/document/check`, {
        params: {
            uuid: values.documentUuid
        },
        headers: {
            // ...(token ? { 'X-Turnstile-Token': token } : null)
        },
    });
};


export const ByNumber = async ({ values }: { values: Types.IForm.ByNumber }) => {
    const token = await getCaptchaToken()
    return http.request.post(`/feedback/rating`, {
        document_number: values.documentNumber,
        document_date: values.documentDate,
    }, {
        headers: {
            ...(token ? { 'X-Turnstile-Token': token } : null)
        },
    });
};
